(function () {
  'use strict';

  const MIN_QUERY_LENGTH = 1;
  const DEBOUNCE_TIME = 200;

  let searchTimer = null;
  let searchController = null;

  function getSearchInput() {
    return document.querySelector(
      'search-modal input[type="search"], ' +
      '#search-modal input[type="search"], ' +
      '.search-modal input[type="search"]'
    );
  }

  function getSearchModal(input) {
    if (!input) return null;

    return (
      input.closest('search-modal') ||
      input.closest('.search-modal') ||
      document.querySelector('search-modal')
    );
  }

  function getResultsContainer(input) {
    const modal = getSearchModal(input);

    if (!modal) return null;

    return (
      modal.querySelector('.search-modal__content-bottom') ||
      modal.querySelector('.search-modal__content') ||
      modal.querySelector('.search-modal__content-top')
    );
  }

  function clearResults(container) {
    if (!container) return;

    /*
     * Remove ONLY our custom search results.
     */
    const results = container.querySelector('.nf-xsearch');

    if (results) {
      results.remove();
    }
  }

  async function performSearch(query, container) {
    if (!container) return;

    /*
     * Cancel previous request
     */
    if (searchController) {
      searchController.abort();
    }

    searchController = new AbortController();

    /*
     * Remove previous custom results
     */
    clearResults(container);

    /*
     * Add loading class only to our custom container
     * if needed later.
     */
    container.classList.add('nf-xsearch-loading');

    try {

      const url =
        '/search?view=nf-predictive' +
        '&type=product' +
        '&q=' +
        encodeURIComponent(query);

      const response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        signal: searchController.signal,
        headers: {
          'Accept': 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error(
          'Search request failed: ' +
          response.status
        );
      }

      const html = await response.text();

      /*
       * Parse returned HTML
       */
      const parser = new DOMParser();

      const doc = parser.parseFromString(
        html,
        'text/html'
      );

      /*
       * Find ONLY our custom search wrapper.
       */
      const newResults =
        doc.querySelector('.nf-xsearch');

      if (!newResults) {
        return;
      }

      /*
       * Make sure old results are gone.
       */
      clearResults(container);

      /*
       * Insert our custom search results.
       *
       * This does NOT replace Dawn's search HTML.
       */
      container.appendChild(newResults);

    } catch (error) {

      if (error.name === 'AbortError') {
        return;
      }

      console.error(
        'NFX predictive search error:',
        error
      );

    } finally {

      container.classList.remove(
        'nf-xsearch-loading'
      );
    }
  }

  function handleSearchInput(event) {

    const input = event.target;

    /*
     * Make sure this is Dawn's search input.
     */
    if (!input.matches(
      'search-modal input[type="search"], ' +
      '#search-modal input[type="search"], ' +
      '.search-modal input[type="search"]'
    )) {
      return;
    }

    /*
     * IMPORTANT:
     *
     * Do NOT stopImmediatePropagation here.
     *
     * We want Dawn to continue handling the
     * search modal itself.
     *
     * We only replace the results visually.
     */

    const container =
      getResultsContainer(input);

    if (!container) {
      return;
    }

    const query =
      input.value.trim();

    /*
     * Cancel previous debounce
     */
    clearTimeout(searchTimer);

    /*
     * Empty search
     */
    if (query.length < MIN_QUERY_LENGTH) {

      clearResults(container);

      return;
    }

    /*
     * Search while typing
     */
    searchTimer = setTimeout(function () {

      performSearch(
        query,
        container
      );

    }, DEBOUNCE_TIME);
  }


  /*
   * Listen before Dawn's handler.
   */
  document.addEventListener(
    'input',
    handleSearchInput,
    true
  );


  /*
   * Clear custom results when modal closes.
   */
  document.addEventListener(
    'click',
    function (event) {

      const closeButton =
        event.target.closest(
          'button[aria-label*="Close"], ' +
          'button.search-modal__close-button, ' +
          '.search-modal__close-button'
        );

      if (!closeButton) {
        return;
      }

      const input =
        getSearchInput();

      const container =
        getResultsContainer(input);

      if (container) {
        clearResults(container);
      }

    }
  );


  /*
   * Also clear when the modal is closed
   * using Escape or other Dawn mechanisms.
   */
  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key !== 'Escape') {
        return;
      }

      const input =
        getSearchInput();

      const container =
        getResultsContainer(input);

      if (container) {
        clearResults(container);
      }

    }
  );

})();